<!-- Vista de Solo Lectura -->
<div *appRole="['Propietarios.Ver']">
  <mat-card *ngIf="!modoEdicion">
    <mat-card-header>
      <mat-card-title>
        Información del Propietario
      </mat-card-title>
      <div class="spacer" style="flex: 1 1 auto;"></div>
      <button mat-icon-button *appRole="['Propietarios.Modificar']" (click)="activarEdicion()"
        matTooltip="Editar propietario">
        <mat-icon>edit</mat-icon>
      </button>
    </mat-card-header>

    <mat-card-content>
      <ngx-spinner [zIndex]="100" name="spUpdatePropietario" bdColor="rgba(255,255,255,0.8)" size="default"
        color="#009688" type="ball-atom" [fullScreen]="false">
      </ngx-spinner>

      <!-- Información Básica -->
      <div class="section">
        <h3 >
          Datos Básicos
        </h3>
        <div class="row">
          <div class="col-md-4">
            <div class="info-field">
              <strong>Comisión:</strong>
              <span class="value">{{ propietario?.comision || 'No definida' }}%</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="info-field">
              <strong>Tipo Liquidación:</strong>
              <span class="value">{{ propietario?.tipoLiquidacion?.descripcion || 'No definido' }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="info-field">
              <strong>CUIT/CUIL:</strong>
              <span class="value">{{ propietario?.cuit || 'No informado' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Información Bancaria -->
      <div class="section" *ngIf="propietario?.cbu || propietario?.nroCuenta || propietario?.alias">
        <h3 >
          Datos Bancarios
        </h3>
        <div class="row">
          <div class="col-md-4" *ngIf="propietario?.nroCuenta">
            <div class="info-field">
              <strong>Número de Cuenta:</strong>
              <span class="value">{{ propietario.nroCuenta }}</span>
            </div>
          </div>
          <div class="col-md-4" *ngIf="propietario?.cbu">
            <div class="info-field">
              <strong>CBU:</strong>
              <span class="value">{{ propietario.cbu }}</span>
            </div>
          </div>
          <div class="col-md-4" *ngIf="propietario?.alias">
            <div class="info-field">
              <strong>Alias:</strong>
              <span class="value">{{ propietario.alias }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Alerta informativa -->
      <mat-card class="alert-card">
        <mat-card-content>
          <div style="display: flex; align-items: center;">
            <mat-icon color="warn" style="margin-right: 8px;">info</mat-icon>
            <span>Los valores de comisión y tipo de liquidación solo se utilizan para la creación de contratos.</span>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-card-content>

    <mat-card-actions align="end">
      <button mat-stroked-button color="warn" *appRole="['Propietarios.Modificar']" (click)="confirmarEliminacion()"
        matTooltip="Eliminar propietario">
        <mat-icon>delete</mat-icon>
        Eliminar
      </button>
    </mat-card-actions>
  </mat-card>
</div>

<!-- Formulario de Edición -->
<div *appRole="['Propietarios.Modificar']">
  <mat-card *ngIf="modoEdicion">
    <mat-card-header>
      <mat-card-title>
        Editar Propietario
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="propietarioForm">
        <ngx-spinner [zIndex]="100" name="spUpdatePropietario" bdColor="rgba(255,255,255,0.8)" size="default"
          color="#009688" type="ball-atom" [fullScreen]="false">
        </ngx-spinner>

        <!-- Datos Básicos -->
        <div class="section">
          <h3 >
            Datos Básicos
          </h3>
          <div class="row">
            <div class="form-group col-md-4">
              <mat-form-field class="example-full-width">
                <span matPrefix>%&nbsp;</span>
                <mat-label>Comisión</mat-label>
                <input matInput name="Comision" cdkFocusInitial appPercentageDirective min="1" max="100" type="number"
                  formControlName="Comision" />
                <mat-error *ngIf="f.Comision.errors?.required">Este campo es requerido.</mat-error>
                <mat-error *ngIf="f.Comision.errors?.min">La comisión debe ser mayor a 0%.</mat-error>
                <mat-error *ngIf="f.Comision.errors?.max">La comisión no puede ser mayor a 100%.</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group col-md-4">
              <mat-form-field class="example-full-width">
                <ngx-spinner name="spTipoLiquidacion" bdColor="rgba(255,255,255,0.8)" size="small" color="#009688"
                  type="line-scale" [fullScreen]="false">
                </ngx-spinner>
                <mat-label>Tipo Liquidación</mat-label>
                <mat-select placeholder="Seleccione opción" formControlName="TipoLiquidacion"
                  (selectionChange)="selectTipoLiquidacion($event)">
                  <mat-option [value]="tipoLiquidacion.id"
                    *ngFor="let tipoLiquidacion of lstTipoLiquidacionModel; trackBy: trackByItems">
                    {{ tipoLiquidacion.descripcion }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="f.TipoLiquidacion.errors?.required">Este campo es requerido.</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>CUIT/CUIL</mat-label>
                <input matInput name="CuitCuil" type="text" [mask]="'00-00000000-0'" placeholder="00-00000000-0"
                  formControlName="CuitCuil" />
                <mat-error *ngIf="f.CuitCuil.errors?.pattern">Formato inválido.</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Datos Bancarios -->
        <!-- <div class="section">
          <h3>
            Datos Bancarios (Opcional)
          </h3>
          <div class="row">
            <div class="form-group col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>Número de Cuenta</mat-label>
                <input matInput name="NroCuenta" type="text" formControlName="NroCuenta" />
              </mat-form-field>
            </div>

            <div class="form-group col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>CBU</mat-label>
                <input matInput name="Cbu" type="text" formControlName="Cbu" placeholder="22 dígitos" maxlength="22" />
                <mat-error *ngIf="f.Cbu.errors?.pattern">El CBU debe tener 22 dígitos.</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group col-md-4">
              <mat-form-field class="example-full-width">
                <mat-label>Alias</mat-label>
                <input matInput name="Alias" type="text" formControlName="Alias" />
              </mat-form-field>
            </div>
          </div>
        </div> -->

        <!-- Alerta informativa -->
        <mat-card class="alert-card">
          <mat-card-content>
            <div style="display: flex; align-items: center;">
              <mat-icon color="warn" style="margin-right: 8px;">info</mat-icon>
              <span>Los valores de comisión y tipo de liquidación no son considerados para la liquidación. Solo se
                utilizan para la creación de un contrato.</span>
            </div>
          </mat-card-content>
        </mat-card>
      </form>
    </mat-card-content>

    <mat-card-actions align="end">
      <button mat-stroked-button (click)="cancelarEdicion()" style="margin-right: 8px;">
        <mat-icon>cancel</mat-icon>
        Cancelar
      </button>
      <button mat-raised-button color="primary" [disabled]="!propietarioForm.valid" (click)="onSubmit()">
        <mat-icon>save</mat-icon>
        Guardar
      </button>
    </mat-card-actions>
  </mat-card>
</div>
